import{useInjection as o}from"inversify-react";import{INVERSIFY_TYPES as n}from"../inversify-types.js";const r=()=>o(n.languageControl);export{r as useLanguageControl};
